<template>
  <div class="card-compare__title">
    <span v-if="attrib.label" class="mb-1">
      {{ attrib.label }}
    </span>
    <font-awesome-icon v-if="attrib.icon" :icon="attrib.icon" />
    <b-img v-if=" attrib?.img || attrib?.field?.img" :src="imgPath + attrib.field.img" fluid />
  </div>
</template>
<script>
export default {
  props: ["attrib", "imgPath"],
  methods: {},
};
</script>
<style>
@media (min-width: 300px) and (max-width: 768px) {
  .text-responsive {
    font-size: calc(1vw + 1vh);
  }
}
</style>
